import { NUMERIC_FRACTIONS, SHAPES } from "rivals/shared/constants";
const { THREE_QUARTERS } = NUMERIC_FRACTIONS;

export const calcWidth = (height: number, shape: SHAPES): number => {
  return shape === SHAPES.CIRCLE ? height : Number(height) * THREE_QUARTERS;
};
